'use strict';
const authenticationAWSModels = require('./authentication-aws-models'),
	authenticationAWSWidgets = require('./authentication-aws-widgets'),
	lib = require('./authentication-aws-lib');

module.exports = function authenticationAWSStart(config, goldApi, navigatorShim, windowObj, ajaxPromise, optional) {
	const models = authenticationAWSModels(lib, config, goldApi, navigatorShim, windowObj, ajaxPromise, optional);
	authenticationAWSWidgets(models, optional);
	return models;
};
